import styled from "@emotion/styled";
import { Dialog } from "@mui/material";
import { useState } from "react";
import theme from "../theme";
import { useI18n } from "../locales";


type Props<T> = {
  open: boolean;
  close: (data: any) => void;
  setForm: (updater: (prev: T) => T) => void;
  width?: string;
};

function NominatimPost<T>({ open, close, setForm, width = "520px" }: Props<T>) {
  const { t } = useI18n();
  const [q, setQ] = useState("");
  const [results, setResults] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const search = async () => {
    if (!q.trim()) return;
    setLoading(true);
    try {
      const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&q=${encodeURIComponent(q)}`);
      const data = await res.json();
      setResults(data);
    } finally {
      setLoading(false);
    }
  };

  const select = (item: any) => {
    setForm((prev: any) => ({
      ...prev,
      address: item.display_name,
    }));
    close(item);
  };

  return (
    <Dialog
      open={open}
      keepMounted
      PaperProps={{
        sx: {
          width,
          borderRadius: "20px",
          pb: "20px",
          margin: "0px",
          padding: "10px 10px 10px 10px",
          background: theme.color.neutral_100,
          maxHeight: '90vh',
        },
      }}
      onClose={close}
    >
      <Header>
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={t?.common?.search || 'Search address'}
          style={{ flex: 1, padding: '8px 12px', borderRadius: 8, border: '1px solid #ccc' }}
          onKeyDown={(e) => { if (e.key === 'Enter') search(); }}
        />
        <SearchBtn onClick={search}>{t?.common?.search || 'Search'}</SearchBtn>
      </Header>
      <List>
        {loading ? (
          <div style={{ padding: 16 }}>Loading...</div>
        ) : (
          results.map((r) => (
            <Item key={`${r.place_id}`} onClick={() => select(r)}>
              {r.display_name}
            </Item>
          ))
        )}
      </List>
    </Dialog>
  );
}

const Header = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 12px 8px 4px 8px;
`;

const SearchBtn = styled.button`
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
`;

const List = styled.div`
  overflow: auto;
  max-height: 70vh;
  padding: 8px;
`;

const Item = styled.div`
  padding: 10px 8px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  &:hover { background: #fafafa; }
`;

export default NominatimPost;


